module.exports = __webpack_public_path__ + "img/launch.092b88c0.png";